import { render, staticRenderFns } from "./wty-style.vue?vue&type=template&id=561f1608&scoped=true&"
import script from "./wty-style.vue?vue&type=script&lang=js&"
export * from "./wty-style.vue?vue&type=script&lang=js&"
import style0 from "./wty-style.vue?vue&type=style&index=0&id=561f1608&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f1608",
  null
  
)

export default component.exports